jQuery(document).ready(function($) {

    /*********** SCROLL SMOOTH **********/
      var btn_scroll = $('.ToBottom');
      var header_height = $('#masthead').height();
      var offsetTop;
     btn_scroll.click(function(e){
      var href = $(this).attr("href");

          offsetTop = href === "#" ? 0 : $(href).offset().top-header_height;
          
               $('html, body').stop().animate({ 
              scrollTop: offsetTop
          }, 500);
       
        e.preventDefault();
    });


    /* if in drawer mode */
  $(".Tabs-Content-js").hide();
  $(".Tabs-Title-js").click(function() {
      
      if($(this).parent().next().css('display') == 'none'){
          $(".Tabs-Content-js").hide();
          var d_activeTab = $(this).attr("rel"); 
          $("#"+d_activeTab).fadeIn();
        
        $(".Tabs-Title-js").removeClass("d_active");
          $(this).addClass("d_active");
        
        //$("ul.tabs li").removeClass("active");
       // $("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
    }else{
      $(this).parent().next().slideUp(400);
      $(".Tabs-Title-js, ul.tabs li").removeClass("d_active");
    }
    });



  //////////////////////
        //// ISOTOPE ////
  /////////////////////

   $(window).load(function() {

    $(".LinkToChild-js").click(function() {
        document.location = $(this).find("a").attr("href");
    });


   /* Code principal */
   function ntp_portfolio_isotope() {
     var $container = $('.grid-rea');

     $container.imagesLoaded(function(){

       $container.isotope({
       itemSelector: '.Rea-Resume-js',
       layoutMode: 'masonry' ,
        percentPosition: true,
        masonry: {

       columnWidth: '.Rea-Resume-sizer',
       gutter: '.Rea-Resume-gutter-sizer',
      percentPosition: true,
       }


       });
     });
   }
   ntp_portfolio_isotope();

   /* Filtre */
   $('.filter a').click(function() {
     var selector = $(this).attr('data-filter');
     $('.grid-rea').isotope({ filter: selector });
     $(this).parents('ul').find('a').removeClass('active');
     $(this).addClass('active');
     return false;
   });

    $('.to_nicedropdown-js').niceSelect();

    $('.to_nicedropdown-js').on('change', function() {

        // var selector = $(this).attr('data-filter');
        // alert(selector);
      $ ('.grid-rea').isotope({ filter: this.value });
      // document.location=this.value;
    });


    $('.to_nicedropdown_to_page-js').niceSelect();

    $('.to_nicedropdown_to_page-js').on('change', function() {
      document.location=this.value;
    });

    


     /* Redimensionnement */
     var isIE8 = $.browser.msie && +$.browser.version === 8;
     if (isIE8) {
     document.body.onresize = function () {
     ntp_portfolio_isotope();
     };
     } else {
     $(window).resize(function () {
     ntp_portfolio_isotope();
     });
   }

   /* Orientation */
   window.addEventListener("orientationchange", function() {
    ntp_portfolio_isotope();
   });

    });



	 /////////////////////
  /// MENU MOBILE /////

  	 var ElementSlider = $('.GalleryTopHome');
  	 var Header = $('#masthead');

  	 var menu_mobile = $('#primary-menu').clone();
  	 var menu_secondaire = $("#secondary-menu li").clone();
  	 menu_mobile.append(menu_secondaire);

	  // menu_mobile.append(menu_rs);
	  menu_mobile.slicknav({
	    duration:300,
	    prependTo : "#masthead",
	    beforeOpen:move_body,
	    beforeClose:move_body,
	    openedSymbol:">",
	    closedSymbol:">"
	  });

  function move_body(){

    if($('.slicknav_btn').hasClass('slicknav_open')){
      $('body').addClass('move_to_right');
    }else{
      $('body').removeClass('move_to_right');
    }
  }

 //// FIN MENU MOBILE /////
 /////////////////////////




	// jQuery MENU JS
	var timer;
	var $present_object;

	$(".dropdown").on("mouseover", function() {

	  clearTimeout(timer);
	  $('.dropdown-menu').removeClass('open');
	  openSubmenu($(this).find('.dropdown-menu'));

	}).on("mouseleave", function() {
	  timer = setTimeout(
	    closeSubmenu, 800);
	});

	function openSubmenu($object) {
			console.log($($object));
	  $($object).addClass("open");
	  $present_object = $object;
	}
	function closeSubmenu() {
	  $($present_object).removeClass("open");
	}

  /* */
  $('.GalleryTopHome').slick({
        //setting-name: setting-value
        dots: true,
        infinite:true,
        arrows:false,
        draggable:false,
        autoplay: true,
        autoplaySpeed: 3000,
        speed:1400,
        fade: true,
        pauseOnHover:false
   });

   $('.GalleryTopRea').slick({
         //setting-name: setting-value
         dots: true,
         infinite:true,
         arrows:false,
         draggable:false,
         autoplay: true,
         autoplaySpeed: 3000,
         speed:1400,
         fade: true,
         pauseOnHover:false
    });



   /* */
   $('.GalleryBottomRea').slick({
         //setting-name: setting-value
         dots: true,
         infinite:true,
         arrows:false,
         draggable:false,
         autoplay: true,
         autoplaySpeed: 3000,
         speed:1400,
         fade: true,
         pauseOnHover:false
    });


     $('.Presse-Slider').slick({
       centerMode: true,
       centerPadding: '60px',
       slidesToShow: 3,
       prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'> < </i></button>",
       nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'> > </i></button>",
       responsive: [
        {
          breakpoint: 769,
          settings: {
            arrows: true,
            centerMode: false,
            centerPadding: '40px',
            slidesToShow: 2,
            infinite:true
          }
        },
        {
          breakpoint: 600,
          settings: {
            arrows: true,
            centerMode: false,
            centerPadding: '40px',
            slidesToShow: 1,
            infinite:true
          }
        }
      ],
      autoplay: false,
      autoplaySpeed: 1000,
      draggable:false,
      pauseOnHover:true,
      arrows:true,
      dots: true,
      infinite:false,
      initialSlide:1


});


  $(window).scroll(function (event) {
    var scroll = $(window).scrollTop();
    var h_element = parseInt(ElementSlider.height() - 250);
    console.log(h_element);
    if(scroll > h_element){
    	Header.addClass('to_scroll_home');
    }else{
    	Header.removeClass('to_scroll_home');
    }
    // Do something
	});


  // Formulaire de contact ///
   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form input[type='tel'], .wpcf7-form select" ).click(function() {
      $( this ).parent().parent().addClass('focus');
  });

    $( ".wpcf7-form label.to_move" ).click(function() {
      $( this ).parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form input[type='tel'],.wpcf7-form textarea, .wpcf7-form select" ).focus(function() {
      $( this ).parent().parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='tel'],.wpcf7-form input[type='text'],.wpcf7-form textarea, .wpcf7-form select" ).each(function() {
      if($(this).val() != '') $( this ).parent().parent().addClass('focus');
  });


  $('#objet').niceSelect();

  $('#objet').on('change', function() {
   $('.nice-select .current').addClass('active');
   $( this ).parent().parent().addClass('focus');
 });

 


   //  WOW EFFECT //
    var wow = new WOW(
      {
        boxClass:     'wow',      // animated element css class (default is wow)
        animateClass: 'animated', // animation css class (default is animated)
        offset:       0,          // distance to the element when triggering the animation (default is 0)
        mobile:       false,       // trigger animations on mobile devices (default is true)
        live:         true,       // act on asynchronously loaded content (default is true)
        callback:     function(box) {
          // the callback is fired every time an animation is started
          // the argument that is passed in is the DOM node being animated
        },
        scrollContainer: null // optional scroll container selector, otherwise use window
      }
    );
   wow.init();

   
}); // fin ready menu
